export const debugQueryParameterNames = [
  "debugRefreshMenuFiltersButton",
  "debugActiveTable",
  "debugExcelExports",
] as const;

export type DebugQueryParameterName = (typeof debugQueryParameterNames)[number];
